import { permissionTypes } from '@/helpers/constants';
import { allPermissions } from '@/helpers/constants';

export default {
  data: () => ({
    permissionTypes,
    allPermissions,
  }),
  computed: {
    userPermissions() {
      return this.$store.getters['user/getPermissionsObject'];
    },
    userId() {
      return this.$store.getters['user/getId'];
    },
  },
  methods: {
    $_allowedGlobalUpdate() {
      return !!this.userPermissions[this.permissionTypes.UPDATE_GLOBALLY];
    },
    $_allowedGlobalDelete() {
      return !!this.userPermissions[this.permissionTypes.DELETE_GLOBALLY];
    },
    $_allowedGlobalOwnContentUpdate(item) {
      return !!this.userPermissions[this.permissionTypes.UPDATE_OWN_GLOBALLY]
        && this.userId === item.user_id;
    },
    $_allowedGlobalOwnContentDelete(item) {
      return !!this.userPermissions[this.permissionTypes.DELETE_OWN_GLOBALLY]
        && this.userId === item.user_id;
    },
    $_allowDeleting(item) {
      return this.$_allowedGlobalDelete() || this.$_allowedGlobalOwnContentDelete(item)
       || this.$_allowDetecting(this.deletePermissionsIds, this.userPermissions, item);
    },
    $_allowCreating() {
      return this.$_allowedGlobalCreate() || this.$_allowDetecting(this.createPermissionsIds, this.userPermissions);
    },
    $_allowUpdating(item) {
      return this.$_allowedGlobalUpdate() || this.$_allowedGlobalOwnContentUpdate(item)
        || this.$_allowDetecting(this.updatePermissionsIds, this.userPermissions, item);
    },
    // item is not nessesary parameter: it serves to check user who created something
    $_allowDetecting(actionPermissions, userPermissions, item) {
      if (!actionPermissions || !actionPermissions.length) return true;
      if (!userPermissions) return false;
      let result = false;
      for (let i = 0; i < actionPermissions.length; i++) {
        const actionPermission = actionPermissions[i];
        const permission = userPermissions[actionPermission];
        if (permission && item && permission.name.includes('own')) {
          result = this.userId === item.user_id;
        } else if (permission) {
          result = true;
        }
        if (result) {
          return result;
        }
      }
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/CommonPageMixin.js